import { render, staticRenderFns } from "./CampaignItem.vue?vue&type=template&id=0b4332a0&scoped=true&"
import script from "./CampaignItem.vue?vue&type=script&lang=ts&"
export * from "./CampaignItem.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignItem.vue?vue&type=style&index=0&id=0b4332a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4332a0",
  null
  
)

export default component.exports